var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "carousel slide carousel-fade",
          attrs: { id: "topCarousel", "data-ride": "carousel" },
        },
        [
          _c(
            "div",
            { staticClass: "carousel-inner", attrs: { role: "listbox" } },
            [
              _c("div", { staticClass: "item active" }, [
                _c("img", {
                  attrs: {
                    src: _vm.UrlService.imagePath(
                      _vm.shop.ShopId,
                      _vm.shop.Image
                    ),
                    alt: _vm.shop.DefaultName,
                  },
                  on: {
                    error: function ($event) {
                      $event.target.src = "dist/assets/no-img.png"
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-center align-items-center abovePic",
                  },
                  [
                    _c("div", { staticClass: "alignContent" }, [
                      _c("div", { staticClass: "blocTitle" }, [
                        _vm.shop.closed
                          ? _c("h1", {
                              staticStyle: { color: "white" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.shop.info.closedDescription
                                ),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "restName" }, [
                          _vm._v(_vm._s(_vm.shop.DefaultName)),
                        ]),
                        _vm._v(" "),
                        _vm.shop.DefaultDescription
                          ? _c("p", { staticClass: "restSub" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.shop.DefaultDescription) +
                                  "\n\t\t\t\t\t\t\t"
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.shop.info.display.hideOrderButtons
                          ? _c(
                              "a",
                              {
                                staticClass: "featLink",
                                attrs: {
                                  href:
                                    _vm.shop.ShopId +
                                    "/carte/0" +
                                    (_vm.shop.ShopId == _vm.shop.GroupId
                                      ? "?start"
                                      : ""),
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "icon-eatselfapp_menu-card",
                                }),
                                _vm._v(" "),
                                _vm.shop.canOrder
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.shop.info.labels.PassezCommande ||
                                            "Passez Commande"
                                        )
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.shop.productTree.product.dn)
                                      ),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shop.reservation
                          ? _c(
                              "a",
                              {
                                staticClass: "featLink booking",
                                on: {
                                  click: function ($event) {
                                    return _vm.UiService.showReservationModal()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "icon-eatselfapp_calendar",
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Réserver une table")]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "Headblock02" }, [
                        _c(
                          "ul",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center",
                          },
                          [
                            _c("li", { staticClass: "countryCompany" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.shop.ShopId + "/accueil#adresse",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-eatselfapp_map-pin",
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(_vm.shop.City))]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "openClose" }, [
                              _vm.ShopService.isOpen()
                                ? _c("div", { staticClass: "openStatus" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            _vm.shop.ShopId +
                                            "/accueil#horaires",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-circle",
                                        }),
                                        _c("span", [_vm._v("Ouvert")]),
                                      ]
                                    ),
                                  ])
                                : _c("div", { staticClass: "closeStatus" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            _vm.shop.ShopId +
                                            "/accueil#horaires",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-circle",
                                        }),
                                        _c("span", [_vm._v("Fermé")]),
                                      ]
                                    ),
                                  ]),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _vm.shop && _vm.shop.description
            ? _c("div", { staticClass: "intro" }, [
                _c("div", { staticClass: "container" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "alignBox" }, [
                    _c("div", {
                      staticClass: "editorHome",
                      domProps: { innerHTML: _vm._s(_vm.shop.description) },
                    }),
                    _vm._v(" "),
                    _vm.shop.description
                      ? _c(
                          "a",
                          {
                            staticClass: "moreAbout",
                            attrs: { href: _vm.shop.ShopId + "/carte/0" },
                          },
                          [
                            _vm.shop.canOrder
                              ? _c("span", [_vm._v("Découvrez nous")])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.shop.productTree.product.dn)
                                  ),
                                ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.shop && !_vm.shop.info.display.hideOrderButtons
            ? _c(
                "div",
                { staticClass: "menuCarte topMain" },
                [
                  _c("categories-carousel", {
                    attrs: {
                      shop: _vm.shop,
                      categories: _vm.shop.productTree.childs,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("home-bottom"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "titleHeading d-flex justify-content-between align-items-center",
      },
      [
        _c("div", { staticClass: "headingTxt" }, [_vm._v("A Propos")]),
        _vm._v(" "),
        _c("div", { staticClass: "headingIcon" }, [
          _c("i", { staticClass: "icon-eatselfapp_on-site" }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }